import { render, staticRenderFns } from "./SdkCard.vue?vue&type=template&id=324d5d0e&scoped=true&"
import script from "./SdkCard.vue?vue&type=script&lang=js&"
export * from "./SdkCard.vue?vue&type=script&lang=js&"
import style0 from "./SdkCard.vue?vue&type=style&index=0&id=324d5d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d5d0e",
  null
  
)

export default component.exports